export default __webpack_public_path__ + "static/media/MERN-STACK-DEVELOPER.3b5bd901.pdf";